export default __webpack_public_path__ + "static/media/importer-color.33b86ebf.svg";